import { IParticipant } from "bets.oddprovider.lib.common.ts/models"
import React from "react"
import { DEFAULTGAP } from "../../globals"
import { EventParticipantComponent } from "./eventParticipant"
import { HeaderComponent } from "../common/header"
import { FormItemStyled, FormStyled } from "fwork.react.apptemplate"

export interface EventParticipantsComponentProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  participants: IParticipant[],
  onSelectItem?: (item: IParticipant, oldItem: IParticipant) => void,
  onDelete?: (item: IParticipant) => void,
  onAdd?: () => void
}

export const EventParticipantsComponent = (props: EventParticipantsComponentProps) => {
  const { participants, onSelectItem, onDelete, onAdd, ...rest } = props

  return <div {...rest} aria-label="EventParticipantsComponent">
    <FormStyled gap={DEFAULTGAP} style={{
      width: '100%'
    }}>
      <FormItemStyled gap={DEFAULTGAP} style={{ width: '100%' }}>
        <HeaderComponent
          title={''}
          onAddClick={props.onAdd}
        />
      </FormItemStyled>

      {props.participants?.map((participant, idx) => <FormItemStyled key={participant.id}
        gap={DEFAULTGAP} style={{
          flexDirection: 'row',
          alignItems: 'center',
          rowGap: DEFAULTGAP,
          columnGap: DEFAULTGAP,
        }}><EventParticipantComponent key={idx} initParticipant={participant}
          onSelectItem={(item: IParticipant) => {
            if (props.onSelectItem)
              props.onSelectItem(item, participant)
          }}
          onDelete={props.onDelete}
        /></FormItemStyled>)}
    </FormStyled>
  </div>
}